import { render, staticRenderFns } from "./CategoryPageContent.vue?vue&type=template&id=79885336&"
import script from "./CategoryPageContent.vue?vue&type=script&lang=js&"
export * from "./CategoryPageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports